import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { MatNativeDateModule,MAT_DATE_LOCALE } from '@angular/material';
import { DatePipe } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ForgotPasswordComponent } from './_root/Trai_module/_pages/forgot-password/forgot-password.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { HomeComponent } from './_root/Trai_module/_pages/home/home.component';
import { HometspComponent } from './_root/Trai_module/_pages/hometsp/hometsp.component';
import { ErrorPageComponent } from './_components/error-page/error-page.component';
import { DashboardRootComponent } from './_root/Trai_module/_pages/dashboard-root/dashboard-root.component';
import { AppRoutingModule } from './_root/Trai_module/_routing/app.routing';
import { TabsHeaderComponent } from './_components/tabs-header/tabs-header.component';
import { HeaderComponent } from './_components/header/header.component';
import { $ModalManagerService } from './_helpers/Modals/ModalManager.service';
import { $BroadcastManagerService } from './_helpers/BroadcastManager.service';
import { FormsModule } from '@angular/forms';
import { ModalSuccessComponent } from './_helpers/Modals/success/modal.success';
import { ModalErrorComponent } from './_helpers/Modals/error/modal.error';
import { ModalPromptComponent } from './_helpers/Modals/prompt/modal.prompt';
import { $ILogger } from './_helpers/Logger/ILogger';
import { $DBManagerService } from './_helpers/DB/DBManager.service';
import { $AuthManagerService } from './_network/AuthManager.service';
import { AuthGuard } from './_network/Auth.guard';
import { HttpMiddleware } from './_network/HttpInterceptor';
import { InterceptorOCP } from './_network/Interceptor';
import { SessionStorage } from './_helpers/DB/session.storage';
import { LocalStorage } from './_helpers/DB/local.storage';


import { ReactiveFormsModule } from '@angular/forms';
import { DndRegistrationDetailsComponent } from './_root/Trai_module/_pages/dnd-registration-details/dnd-registration-details.component';
import { CheckBoxGroupComponent } from './_components/checkbox-root/checkbox-group.component';
import { CheckboxComponent } from './_components/checkbox-root/checkbox/checkbox.component';
import { APIDndRegistrationDetails } from './_root/Trai_module/_services/dnd-registration-details/API-dnd-registration-details';
import { LoaderComponent } from './_components/loader/loader.component';
import { EntitySummaryComponent } from './_root/Trai_module/_pages/entity-summary/entity-summary.component';
import { FooterComponent } from './_components/footer/footer.component';

import {DemoMaterialModule} from '../material-module';
import { EntityRegistrationComponent } from './_root/Trai_module/_pages/entity-registration/entity-registration.component';

import {CommonLoginComponent} from './_root/Trai_module/_pages/common-login/common-login.component';
import { APILoginService } from './_root/Trai_module/_services/login/API-login';
import { APIEntityService } from './_root/Trai_module/_services/entity/API-entity';
// url whitelist service
import { APIURLRegisterService } from './_root/Trai_module/_services/url-register/API-urlregister'

import { DropDownDirective } from './_components/tabs-header/drop-down.directive';
import {SubscriberLoginComponent} from './_root/Trai_module/_pages/subscriber-login/subscriber-login.component';
import {MatPaginatorModule} from '@angular/material/paginator';
import {DataSource} from '@angular/cdk/table';
import { filter } from 'rxjs/operators';

import {MyDialogComponent} from './_helpers/Modals/my-dialog/my-dialog.component';
import { EntityDialogComponent} from './_helpers/Modals/entity-dialog/entity-dialog.component';
import { APIEncryptionDecryption } from './_root/Trai_module/_services/CommonService/API-Common-Service';
import { PreferenceSummaryComponent } from './_root/Trai_module/_pages/preference-summary/preference-summary.component';
import { ImportPreferenceComponent } from './_root/Trai_module/_pages/import-preference/import-preference.component';
import { APIImportPreferenceService } from './_root/Trai_module/_services/import-preference/API-import-preference';
import { PreferenceNcprDetailsComponent } from './_root/Trai_module/_pages/preference-ncpr-details/preference-ncpr-details.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { LoginActivateService } from './_root/Trai_module/_services/loginactivate.service';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { BnNgIdleService } from 'bn-ng-idle'; 

import { PrefrenceDownloadComponent } from './_root/Trai_module/_pages/prefrence-download/prefrence-download.component';
import { InviteUsersComponent } from './_root/Trai_module/_pages/invite-users/invite-users.component';

import { BadWordsImportComponent } from './_root/Trai_module/_pages/bad-words-import/bad-words-import.component';


import { SearchDndPreferenceComponent } from './_root/Trai_module/_pages/search-dnd-preference/search-dnd-preference.component';

import { APIHeaderService } from './_root/Trai_module/_services/header/API-header';
import { APITelemarketerHeaderRegistration } from './_root/Trai_module/_services/telemarketer-header-registration/API-telemarketer-header-registration';

import { APIIPRegisterService } from './_root/Trai_module/_services/ip-register/API-ipregister';
import { APIPaymentService } from './_root/Trai_module/_services/payment-dues/payment-dues.service';

import { ComplaintRegistrationSubscriberComponent } from './_root/Trai_module/_pages/complaint-registration-subscriber-02/complaint-registration-subscriber-02.component';
import { ComplaintRegistrationSubscriber01Component } from './_root/Trai_module/_pages/complaint-registration-subscriber-01/complaint-registration-subscriber-01.component';


 import { ComplaintsNcprSummaryComponent } from './_root/Trai_module/_pages/complaints-ncpr-summary/complaints-ncpr-summary.component';
 import { ComplaintsNcprDetailsComponent } from './_root/Trai_module/_pages/complaints-ncpr-details/complaints-ncpr-details.component';
 import { ComplaintsDownloadComponent } from './_root/Trai_module/_pages/complaints-download/complaints-download.component';
 import { ComplaintsSummaryComponent } from './_root/Trai_module/_pages/complaints-summary/complaints-summary.component';
 import { APIComplaintsService } from './_root/Trai_module/_services/complaints/API-complaints';
 import { EntityIdDetailsComponent } from './_root/Trai_module/_pages/principal-header-summary/entity-id-details/entity-id-details.component';
 import { APIHelpdeskService } from './_root/Trai_module/_services/helpdesk/API-helpdesk';


 import { APITemplateService } from './_root/Trai_module/_services/template/API-template';    
 import { ContentTemplateRegistrationComponent } from './_root/Trai_module/_pages/content-template-registration/content-template-registration.component';
 import { ContentTemplateRegistrationActionComponent } from './_root/Trai_module/_pages/content-template-registration-action/content-template-registration-action.component';
 import { TemplateModificationComponent } from './_root/Trai_module/_pages/template-modification/template-modification.component';
 import { TemplatesByPEComponent } from './_root/Trai_module/_pages/templates-by-pe/templates-by-pe.component'; 
 import { ContentTemplateBulkUploadSummaryComponent } from './_root/Trai_module/_pages/content-template-bulk-upload-summary/content-template-bulk-upload-summary.component';
 import { BulkContentUploadComponent } from './_root/Trai_module/_pages/bulk-content-upload/bulk-content-upload.component';

 
import {ConsentRegComponent} from './_root/Trai_module/_pages/consent-new-registration/consent-new-registration.component';
import { BulkConsentTemplateRegistrationComponent } from './_root/Trai_module/_pages/bulk-consent-template-registration/bulk-consent-template-registration.component';
import {ConsentTemplateBulkUploadSummaryComponent } from './_root/Trai_module/_pages/consent-template-bulk-upload-summary/consent-template-bulk-upload-summary.component';
import { EntityConsentReportComponent } from './_root/Trai_module/_pages/entity-consent-template-report/entity-consent-template-report.component';

//HeaderComponent

import { HeaderIdDetailsComponent } from './_root/Trai_module/_pages/header-id-details/header-id-details.component';
import { PrincipalHeaderSummaryComponent } from './_root/Trai_module/_pages/principal-header-summary/principal-header-summary.component';
//import { PrincipalHeaderRegistrationComponent } from './_root/Trai_module/_pages/principal-header-registration/principal-header-registration.component';
import { HeaderVoiceComponent } from './_root/Trai_module/_pages/header-voice/header-voice.component';
import { HeaderVoiceSummaryComponent } from './_root/Trai_module/_pages/header-voice-summary/header-voice-summary.component';


import { HeaderModifyComponent } from './_root/Trai_module/_pages/header-modify/header-modify.component';
import { HeadersByPeComponent } from './_root/Trai_module/_pages/headers-by-pe/headers-by-pe.component';
import { HeaderRegComponent } from './_root/Trai_module/_pages/new-header-registration/new-header-registration.component';  
import { HeaderBulkDetailsComponent } from './_root/Trai_module/_pages/header-bulk-details/header-bulk-details.component';
import { ImportHeaderComponent } from './_root/Trai_module/_pages/import-header/import-header.component';
import { HeaderSummaryComponent } from './_root/Trai_module/_pages/header-summary/header-summary.component';

//Consent-Migration
// import {BulkConsentuploadComponent } from './_root/Trai_module/_pages/bulk-consent-upload/bulk-consent-upload.component';
import { ConsentReportsComponent } from './_root/Trai_module/_pages/consent-reports/consent-reports.component';
import { ConsentBulkSummaryComponent } from './_root/Trai_module/_pages/consent-bulk-upload-summary/consent-bulk-upload-summary.component';

import { APIConsentService } from './_root/Trai_module/_services/consent/API-consent'; 


//Entity-Phase I
import { ChangePasswordComponent } from './_root/Trai_module/_pages/change-password/change-password.component';
import { TMPECommonRegistrationComponent01 } from './_root/Trai_module/_pages/tmpe-common-registration-01/tmpe-common-registration-01.component';
import { TMPECommonRegistrationComponent02 } from './_root/Trai_module/_pages/tmpe-common-registration-02/tmpe-common-registration-02.component';
import { TMPEModifyAfterApprovalComponent } from './_root/Trai_module/_pages/tmpe-modify-after-approval/tmpe-modify-after-approval.component';
import { TMPEModifyBeforeApprovalComponent } from './_root/Trai_module/_pages/tmpe-modify-before-approval/tmpe-modify-before-approval.component';
import { TmpeCommonLoginComponent } from './_root/Trai_module/_pages/tmpe-common-login/tmpe-common-login.component';
import { ModalPromptEntityComponent } from './_helpers/Modals/prompt-entity/modal.prompt-entity';

import { EntityAuditLogComponent } from './_root/Trai_module/_pages/entity-auditlog/entity-auditlog.component';
import { EntityEditLogComponent } from './_root/Trai_module/_pages/entity-editlog/entity-editlog.component';
import { EntityReportComponent } from './_root/Trai_module/_pages/entity-report/entity-report.component';
import { EntityVerificationComponent } from './_root/Trai_module/_pages/entity-verification/entity-verification.component';
import { EntityWorklistComponent } from './_root/Trai_module/_pages/entity-worklist/entity-worklist.component';
import { TataCommonLoginComponent } from './_root/Trai_module/_pages/tata-common-login/tata-common-login.component';
import { TataEntityModificationComponent } from './_root/Trai_module/_pages/tata-entity-modification/tata-entity-modification.component';
import { TataEntityRegistrationComponent } from './_root/Trai_module/_pages/tata-entity-registration/tata-entity-registration.component';
import { ModifyRegistrarComponent } from './_root/Trai_module/_pages/modify-registrar/modify-registrar.component';
import { TtlusersReportComponent } from './_root/Trai_module/_pages/ttlusers-report/ttlusers-report.component';
import { TtlusersSummaryComponent } from './_root/Trai_module/_pages/ttlusers-summary/ttlusers-summary.component';
import { TataAuditLogComponent } from './_root/Trai_module/_pages/tata-auditlog/tata-auditlog.component';

//observer
import { DashboardComponent } from './_root/Trai_module/_observer/dashboard/dashboard.component';
import { EntityObvComponent } from './_root/Trai_module/_observer/entity-obv/entity-obv.component';
import { HeaderObvComponent } from './_root/Trai_module/_observer/header-obv/header-obv.component';
import { ConsentObvComponent } from './_root/Trai_module/_observer/consent-obv/consent-obv.component';

//Observer - Complaints
import { ComplaintsObvDashboardOapComponent } from './_root/Trai_module/_observer/complaints-obv-dashboard-oap/complaints-obv-dashboard-oap.component';
import { ComplaintsObvComprehensiveRptComponent } from './_root/Trai_module/_observer/complaints-obv-comprehensive-rpt/complaints-obv-comprehensive-rpt.component';

import { TelemarketerObvComponent } from './_root/Trai_module/_observer/telemarketer-obv/telemarketer-obv.component';
import { ConsentTemplateObvComponent } from './_root/Trai_module/_observer/consent-template-obv/consent-template-obv.component';
import { ContentTemplateObvComponent } from './_root/Trai_module/_observer/content-template-obv/content-template-obv.component';
import { ComplaintsObvComponent } from './_root/Trai_module/_observer/complaints-obv/complaints-obv.component';
import { SearchDndPreferenceObvComponent } from './_root/Trai_module/_observer/search-dnd-preference-obv/search-dnd-preference-obv.component';
import { OperatorWiseCountComponent } from './_root/Trai_module/_observer/operator-wise-count/operator-wise-count.component';
import { APIObserverService } from './_root/Trai_module/_observerServices/API-Observer';
import { ChartsModule as Ng2Charts } from 'ng2-charts';

import { IpRegistrationComponent } from './_root/Trai_module/_pages/ip-registration/ip-registration.component';

import { PaymentDuesComponent } from './_root/Trai_module/_pages/payment-dues/payment-dues.component';
import { PaymentHistoryComponent } from './_root/Trai_module/_pages/payment-history/payment-history.component';
import { PaymentSubmitComponent } from './_root/Trai_module/_pages/payment-submit/payment-submit.component';
import { PaymentreceiptComponent }from './_root/Trai_module/_pages/paymentreceipt/paymentreceipt.component';

import { GstRegistrationService } from './_root/Trai_module/_services/gst-registration/gst-registration.service';
import { GstRegistrationComponent } from './_root/Trai_module/_pages/gst-registration/gst-registration.component'
import { GstRegistrationDetailsComponent } from './_root/Trai_module/_pages/gst-registration-details/gst-registration-details.component';
import { GstregistrationSearchComponent } from './_root/Trai_module/_pages/gstregistration-search/gstregistration-search.component';

import { LinkingConsentComponent} from'./_root/Trai_module/_pages/linking_consent/linking_consent.component';
import { NonTTLTemplatesComponent } from './_root/Trai_module/_pages/non-ttl-templates/non-ttl-templates.component';

import { CaptureRequestOnPEComponent } from './_root/Trai_module/_pages/capture-request-onpe/capture-request-onpe.component';
import { RequestStatusComponent } from './_root/Trai_module/_pages/request-status/request-status.component';

import { ConsentAcquisitionComponent } from './_root/Trai_module/_pages/consent-acquisition/consent-acquisition.component';
import { ConsentAcquisitionQRCodeComponent } from './_root/Trai_module/_pages/consent-acquisition-qrcode/consent-acquisition-qrcode.component';
import { ConsentStatusSummaryComponent } from './_root/Trai_module/_pages/consent-status-summary/consent-status-summary.component';
import { ConsentAcquisitionScanPgComponent } from './_root/Trai_module/_pages/consent-acquisition-scanpg/consent-acquisition-scanpg.component';
import { ConsentAcqQrComponent } from './_root/Trai_module/_pages/consentacqqr/consentacqqr.component';
import { DigitalConsentsummaryComponent } from './_root/Trai_module/_pages/digital-consentsummary/digital-consentsummary.component';
import { ActivateDigitalConsentComponent } from './_root/Trai_module/_pages/activate-digital-consent/activate-digital-consent.component';

import { TemplatecontentmodifyComponent } from './_root/Trai_module/_pages/templatecontentmodify/templatecontentmodify.component';
import { BulkTemplateVerificationComponent } from './_root/Trai_module/_pages/bulk-template-verification/bulk-template-verification.component';
import { BulkTemplateVerificationSummaryComponent } from './_root/Trai_module/_pages/bulk-template-verification-summary/bulk-template-verification-summary.component';

//Header Extension Conversion
import { HeaderSuspensionComponent } from './_root/Trai_module/_pages/header-suspension/header-suspension.component';
import { ExtensionConversionHeadersComponent } from './_root/Trai_module/_pages/extension-conversion-headers/extension-conversion-headers.component';


//voice
import { VoiceService } from './_root/Trai_module/_services/voice/voice';
import { VoiceHeaderRegTMComponent } from './_root/Trai_module/_pages/voice-header-registration-tm/voice-header-registration-tm.component';
import { VoiceHeaderModTMComponent } from './_root/Trai_module/_pages/voice-header-modification-tm/voice-header-modification-tm.component';
import { VoiceHeaderRegPEComponent } from './_root/Trai_module/_pages/voice-header-registration-pe/voice-header-registration-pe.component';
import { VoiceHeaderModPEComponent } from './_root/Trai_module/_pages/voice-header-modification-pe/voice-header-modification-pe.component';
import { VoiceHeaderreglistpeComponent } from './_root/Trai_module/_pages/voice-header-reg-list-pe/voice-header-reg-list-pe.component';
import { VoiceHeaderreglisttmComponent } from './_root/Trai_module/_pages/voice-header-reg-list-tm/voice-header-reg-list-tm.component';


import { VoiceTemplateRegDetailsBypeComponent } from './_root/Trai_module/_pages/voice-template-reg-details-by-pe/voice-template-reg-details-by-pe.component';
import { VoiceTemplatesByPeComponent } from './_root/Trai_module/_pages/voice-templates-by-pe/voice-templates-by-pe.component';
import { VoiceTemplateModificationbyPeComponent } from './_root/Trai_module/_pages/voice-template-modification-pe/voice-template-modification-pe.component';
import { VoiceContentTemplateRegComponent } from './_root/Trai_module/_pages/voice-Template-reg-by-pe/voice-Template-reg-by-pe.component';
import { VoicehdrDialogComponent } from './_helpers/Modals/voicehdr-dialog/voicehdr-dialog.component';

//PE
import {VoiceServiceHeaderreglistpeComponent} from './_root/Trai_module/_pages/voice-service-header-reg-list-pe/voice-service-header-reg-list-pe.component';
import {VoiceServiceHeaderRegPEComponent} from './_root/Trai_module/_pages/voice-service-header-registration-pe/voice-service-header-registration-pe.component';
import { VoiceServiceHeaderModificationPeComponent } from './_root/Trai_module/_pages/voice-service-header-modification-pe/voice-service-header-modification-pe.component';

//TM
import {VoiceServiceHeaderRegTMComponent} from './_root/Trai_module/_pages/voice-service-header-registration-tm/voice-service-header-registration-tm.component';
import {VoiceServiceHeaderreglisttmComponent} from './_root/Trai_module/_pages/voice-service-header-reg-list-tm/voice-service-header-reg-list-tm.component';

 //url-register
 import { UrlRegisterListComponent } from './_root/Trai_module/_pages/url-register-list/url-register-list.component';
 import { UrlRegistrationComponent } from './_root/Trai_module/_pages/url-registration/url-registration.component';
 
//pe side - petm binding
import { PETMBindingNewChainComponent } from './_root/Trai_module/_pages/petmbinding-new-chain-creation/petmbinding-new-chain-creation.component';
import {PETMBindingPEListComponent } from './_root/Trai_module/_pages/petmbinding-pelist/petmbinding-pelist.component';
//tm,ta td side - PEtm binding 
import {PETMBindingTMTATDListComponent} from './_root/Trai_module/_pages/petmbinding-tmtatdlist/petmbinding-tmtatdlist.component';
// utm registration - PEtm binding
import {UTMCommonLoginComponent} from './_root/Trai_module/_pages/utm-common-login/utm-common-login.component';
//petm binding - Surekha - on tmtatd side
import { PETMBindingDialogComponent } from './_helpers/Modals/petmbinding-dialog/petmbinding-dialog.component';

//Entity KYC renewal process
import { EntityKycRenewalProcessComponent } from './_root/Trai_module/_pages/entity-kyc-renewal-process/entity-kyc-renewal-process.component';

const _APIServices = [
  
  APIDndRegistrationDetails,

  APILoginService,
  
  APIEntityService,
  
  APIEncryptionDecryption,
  APIImportPreferenceService,
  APIHeaderService,
  APITelemarketerHeaderRegistration,
  APIComplaintsService,
  APIHelpdeskService,
  APITemplateService,
  APIConsentService,
  APIObserverService,
  APIIPRegisterService,
  APIPaymentService,
  GstRegistrationService,
  VoiceService,
  APIURLRegisterService

];

const _providers = [
  $DBManagerService,
  $BroadcastManagerService,
  $ModalManagerService,
  $AuthManagerService,
  $ILogger,
  AuthGuard,
  SessionStorage,
  LocalStorage,
  HttpMiddleware,
  InterceptorOCP,
  LoginActivateService,
  BnNgIdleService,
  DatePipe
];

const _components = [
  CheckBoxGroupComponent,
  CheckboxComponent,
  LoaderComponent
];

const _commonComponents = [
  TabsHeaderComponent,
  ErrorPageComponent,
  HeaderComponent,
  FooterComponent,

];

const _entryComponents = [
  
  ModalSuccessComponent,
  ModalErrorComponent,
  ModalPromptComponent,
  
  MyDialogComponent,
  EntityDialogComponent,
  ModalPromptEntityComponent,
  VoicehdrDialogComponent,
  //petm binding - Surekha - on tmtatd side
  PETMBindingDialogComponent
  
];


const _declarations = [
  AppComponent,
  
  DashboardRootComponent,
  HomeComponent,
  HometspComponent,
   DndRegistrationDetailsComponent,
 
  PreferenceSummaryComponent,
 
   EntitySummaryComponent,
  
  EntityRegistrationComponent,
  
  CommonLoginComponent,
  
  DropDownDirective,
  SubscriberLoginComponent,

ImportPreferenceComponent,
PreferenceNcprDetailsComponent,

InviteUsersComponent,
PrefrenceDownloadComponent,
  BadWordsImportComponent,
//RootHeaderComponent,
HeaderVoiceComponent,
HeaderVoiceSummaryComponent,
//RootHeaderSummaryComponent,
ForgotPasswordComponent,

SearchDndPreferenceComponent,
PrincipalHeaderSummaryComponent,
//PrincipalHeaderRegistrationComponent,
 ComplaintsNcprSummaryComponent,
 ComplaintsNcprDetailsComponent,
 ComplaintsDownloadComponent,
 ComplaintsSummaryComponent,
 HeaderIdDetailsComponent,
 EntityIdDetailsComponent,
  ..._entryComponents,
  ..._commonComponents,
  ..._components,
  ContentTemplateRegistrationComponent,
ContentTemplateRegistrationActionComponent,
ContentTemplateBulkUploadSummaryComponent,
BulkContentUploadComponent,
TemplateModificationComponent,
TemplatesByPEComponent,
ConsentRegComponent,
BulkConsentTemplateRegistrationComponent,
ConsentTemplateBulkUploadSummaryComponent,
EntityConsentReportComponent,

//Header

HeaderModifyComponent,
HeadersByPeComponent,
HeaderRegComponent,
HeaderBulkDetailsComponent,
ImportHeaderComponent,
HeaderSummaryComponent,

//Consent Migration

// BulkConsentuploadComponent,
ConsentReportsComponent,
ConsentBulkSummaryComponent,


ChangePasswordComponent,
TMPECommonRegistrationComponent01,
TMPECommonRegistrationComponent02,
TMPEModifyAfterApprovalComponent,
TMPEModifyBeforeApprovalComponent,
TmpeCommonLoginComponent,
EntityAuditLogComponent,
EntityEditLogComponent,
EntityReportComponent,
EntityVerificationComponent,
EntityWorklistComponent,
TataCommonLoginComponent,
TataEntityModificationComponent,
TataEntityRegistrationComponent,
ModifyRegistrarComponent,
TtlusersReportComponent,
TtlusersSummaryComponent,
TataAuditLogComponent,
ComplaintRegistrationSubscriberComponent,
ComplaintRegistrationSubscriber01Component,
//Observer Starts
DashboardComponent,
HeaderObvComponent,
ConsentObvComponent,
EntityObvComponent,
TelemarketerObvComponent,
ConsentTemplateObvComponent,
ContentTemplateObvComponent,
ComplaintsObvComponent,
SearchDndPreferenceObvComponent,
OperatorWiseCountComponent,
//observer complaints
ComplaintsObvDashboardOapComponent,
ComplaintsObvComprehensiveRptComponent,

IpRegistrationComponent,
PaymentDuesComponent,
PaymentHistoryComponent,
PaymentSubmitComponent,
PaymentreceiptComponent,
GstRegistrationComponent,
GstRegistrationDetailsComponent,
GstregistrationSearchComponent,
LinkingConsentComponent,
NonTTLTemplatesComponent,
RequestStatusComponent,
CaptureRequestOnPEComponent,
ConsentAcquisitionComponent,
ConsentAcquisitionQRCodeComponent,
ConsentStatusSummaryComponent,
ConsentAcquisitionScanPgComponent,
ConsentAcqQrComponent,
DigitalConsentsummaryComponent,
ActivateDigitalConsentComponent,
TemplatecontentmodifyComponent,
BulkTemplateVerificationComponent,
BulkTemplateVerificationSummaryComponent,
HeaderSuspensionComponent,
ExtensionConversionHeadersComponent,

//Voice

  VoiceHeaderRegTMComponent,
  VoiceHeaderModTMComponent,
  VoiceHeaderreglisttmComponent,
  VoiceHeaderRegPEComponent,
  VoiceHeaderModPEComponent,
  VoiceHeaderreglistpeComponent,
  VoiceContentTemplateRegComponent,
  VoiceTemplatesByPeComponent,
  VoiceTemplateRegDetailsBypeComponent,
  VoiceTemplateModificationbyPeComponent,

  //voice service
   //PE
VoiceServiceHeaderreglistpeComponent,
VoiceServiceHeaderRegPEComponent,
VoiceServiceHeaderModificationPeComponent,
//TM
VoiceServiceHeaderRegTMComponent,
VoiceServiceHeaderreglisttmComponent,

  //url-register
UrlRegisterListComponent,
UrlRegistrationComponent,

//pe side - petm binding
PETMBindingNewChainComponent,
PETMBindingPEListComponent,
//tmtatd side - petm binding
PETMBindingTMTATDListComponent,
//utm side - petm binding
UTMCommonLoginComponent,

//Entity KYC Renewal Process
EntityKycRenewalProcessComponent

];


const _imports = [
  BrowserModule,
  FormsModule,
  HttpClientModule,
  DemoMaterialModule,
  ModalModule.forRoot(),
  BsDatepickerModule.forRoot(),
  AppRoutingModule,
  ReactiveFormsModule,
  BrowserAnimationsModule,
  MatNativeDateModule,
  MatPaginatorModule,
  NgxSpinnerModule,
  NgIdleKeepaliveModule,
  //filter 
  Ng2Charts,

  
];

@NgModule({
  declarations: _declarations,
  imports: _imports,
  providers: [
    ..._providers,
    ..._APIServices,
    {provide: MAT_DATE_LOCALE, useValue: 'en-GB'},

  ],
  entryComponents: _entryComponents,
  bootstrap: [AppComponent]
})
export class AppModule { }

